<template>
  <div v-loading="loading">
    <div ref="tablePrint" class="print">
      <div style="margin-top: 10px; height: 650px; overflow: auto">
        <div id="tablePrint">
          <buffetTable :tabelTitel="tabelTitel" :listQuery="listQuery" :tabelList="tabelList" :sumsTotal="sumsTotal" :groupSums="groupSums"></buffetTable>
        </div>
      </div>
    </div>
    <div ref="tablePrintExport" class="Export_table" v-show="false">
      <div style="margin-top: 10px; height: 650px; overflow: auto">
        <div id="tablePrintExport">
          <buffetTable :tabelTitel="tabelTitel" :listQuery="listQuery" :exportShow="true" :tabelList="tabelList" :sumsTotal="sumsTotal" :groupSums="groupSums"></buffetTable>
        </div>
      </div>
    </div>
    <div id="copy_div" v-show="false" style="'width:100%'" class="'flex-seting'"></div>
  </div>
</template>
<script>
import DateUtils from '@/utils/DateUtils';
import buffetTable from './buffetTable.vue';
import getLodop from '../../utils/Lodopfuncs';

export default {
  components: {
    buffetTable,
  },
  data() {
    return {
      listQuery: {
        businessDate: DateUtils.formatDate(new Date(), 'yyyy-MM-dd '),
        setMealIds: [],
      },
      hotelInfo: localStorage.getItem('hotelInfo'),
      loading: false,
      tabelTitel: [
        {
          code: 'accountCode',
          chinese_desc: '房间账号',
        },
        {
          code: 'roomNum',
          chinese_desc: '房号',
        },
        {
          code: 'name',
          chinese_desc: '姓名',
        },
        {
          code: 'status',
          chinese_desc: '状态',
        },
        {
          code: 'cardNum',
          chinese_desc: '会员卡号',
        },
        {
          code: 'corpName',
          chinese_desc: '单位名称',
        },
        {
          code: 'groupName',
          chinese_desc: '团队名称',
        },
        {
          code: 'arriveTime',
          chinese_desc: '到达日期',
        },
        {
          code: 'leaveTime',
          chinese_desc: '离开日期',
        },
        {
          code: 'setMealName',
          chinese_desc: '包价',
        },
        {
          code: 'quantity',
          chinese_desc: '可用餐数量',
        },
        {
          code: 'businessDate',
          chinese_desc: '就餐日期',
        },
        {
          code: 'total2',
          chinese_desc: '包价金额',
        },
        {
          code: 'payTotal',
          chinese_desc: '自费金额',
        },
        {
          code: 'writeOffCount',
          chinese_desc: '核销数量',
        },
        {
          code: 'writeOffTotal',
          chinese_desc: '核销金额',
        },
        {
          code: 'writeOffPayTotal',
          chinese_desc: '自费入账金额',
        },
        {
          code: 'writeOffTime',
          chinese_desc: '核销时间',
        },
        {
          code: 'unWriteOffCount',
          chinese_desc: '未核销数量',
        },
      ],
      tabelList: [],
    };
  },
  created() {
    this.getInit();
    this.$bus.$on('todoQuery', this.getData);
    this.$bus.$on('todoPrintCatering', this.todoPrint);
    this.$bus.$on('todoExportCatering', this.todoExport);
  },
  beforeDestroy() {
    this.$bus.$off('todoQuery', this.getData);
    this.$bus.$off('todoPrintCatering', this.todoPrint);
    this.$bus.$off('todoExportCatering', this.todoExport);
  },
  computed: {
    sumsTotal: function () {
      let sums = [];
      this.tabelTitel.map((item, index) => {
        this.tabelList.map(sItem => {
          if (['total2', 'quantity', 'payTotal', 'writeOffCount', 'writeOffTotal', 'writeOffPayTotal', 'unWriteOffCount'].includes(item.code)) {
            if (!sums[index]) {
              sums[index] = 0;
            }
            if (sItem[item.code]) {
              sums[index] = Number(sums[index]) + Number(sItem[item.code]);
            }
            sums[index] = sums[index] + '';
          }
        });
      });
      if (this.tabelTitel.length) {
        sums[0] = '合计';
      }
      return sums;
    },
    //  按团队名称分组统计的小计
    groupSums: function () {
      // 需要合计的字段列表
      const sumFields = ['total2', 'quantity', 'payTotal', 'writeOffCount', 'writeOffTotal', 'writeOffPayTotal', 'unWriteOffCount'];
      // 存储每个团队的小计数据
      const groups = {};

      this.tabelList.forEach(item => {
        const groupName = item.groupName || '无团队'; // 如果团队名称为空，归为“无团队”
        if (!groups[groupName]) {
          // 初始化该团队的合计对象，字段值初始为0
          groups[groupName] = {};
          sumFields.forEach(field => {
            groups[groupName][field] = 0;
          });
        }
        // 累加各字段
        sumFields.forEach(field => {
          const value = Number(item[field]) || 0;
          groups[groupName][field] += value;
        });
      });

      // 转换为数组，以便传递给子组件
      return Object.entries(groups).map(([groupName, values]) => ({
        groupName,
        ...values,
      }));
    },
  },
  methods: {
    getData(val) {
      this.listQuery = Object.assign({}, val);
      this.getInit();
    },
    getInit() {
      let data = this.listQuery;
      this.$axios({
        methods: 'post',
        url: this.api.kcReportList,
        data,
      }).then(res => {
        if (res.data.status == 0) {
          this.tabelList = res.data.data || [];
        }
      });
    },
    todoPrint(type) {
      const LODOP = getLodop();
      // 获取大小和宽度
      let printSize = this.$store.state.user.printSize ? this.$store.state.user.printSize : 12;
      let width = this.$store.state.user.printWidth ? this.$store.state.user.printWidth : 2;
      if (LODOP) {
        // 判断是否是数字
        let falg = false;
        if (document.getElementById('tablePrint')) {
          document.getElementById('copy_div').innerHTML = '';
          let innerHTML = document.getElementById('tablePrint').cloneNode(true);
          innerHTML.style.border = 'none';
          innerHTML.style.borderCollapse = 'collapse';
          innerHTML.style.fontSize = printSize + 'px';
          document.getElementById('copy_div').appendChild(innerHTML);
          falg = true;
        }
        this.$nextTick(() => {
          var strFormHtml =
            `
                <body >` +
            document.getElementById(falg ? 'copy_div' : 'tablePrint').innerHTML +
            '</body>'; //获取打印内容
          LODOP.PRINT_INIT(''); //初始化
          LODOP.SET_PRINT_PAGESIZE(0, 0, 0, 'A4'); //设置打印方向
          LODOP.ADD_PRINT_TABLE('2%', width + '%', 100 - width * 2 + '%', '88%', strFormHtml);
          LODOP.SET_PRINT_STYLEA(0, 'Offset2Top', -100);
          LODOP.SET_PRINT_STYLEA(0, 'LetterSpacing', 0);
          LODOP.SET_PREVIEW_WINDOW(2, 0, 0, 800, 600, ''); //设置预览窗口模式和大小
          LODOP.ADD_PRINT_TEXT(566, 542, 165, 22, '第#页/共&页');
          LODOP.SET_PRINT_STYLEA(0, 'ItemType', 2);
          LODOP.SET_PRINT_STYLEA(0, 'Horient', 2);
          LODOP.SET_PRINT_STYLEA(0, 'Vorient', 1);
          if (type === 'preview') {
            LODOP.PREVIEW();
          } else {
            LODOP.PRINT();
          }
        });
      }
    },
    todoExport() {
      const LODOP = getLodop();
      if (LODOP) {
        // 获取大小和宽度
        let width = 2;
        var strFormHtml = '<body>' + document.getElementById('tablePrintExport').innerHTML + '</body>'; //获取打印内容
        LODOP.PRINT_INIT(''); //初始化
        LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4'); //设置纵向
        LODOP.ADD_PRINT_TABLE('2%', width + '%', 100 - width * 2 + '%', '88%', strFormHtml);
        LODOP.SET_PRINT_STYLEA(0, 'Offset2Top', -100);
        LODOP.SAVE_TO_FILE('自助核销统计报表.xlsx');
      }
    },
  },
};
</script>
